
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"profile-preferences-flame","d":"M20.777 19.65a2.077 2.077 0 01-3.325-.54l-.748-1.5a6.956 6.956 0 00-2.037 4.92v.173a7.13 7.13 0 007.13 7.13 7.13 7.13 0 007.13-7.13c0-1.932-.875-3.76-2.38-4.971l-1.105-.892a6.392 6.392 0 01-2.22-3.554l-.408-1.786a8.074 8.074 0 00-2.207 7.293l.17.856z"}})]),_c('path',{attrs:{"d":"M7 29.223V9.667A3.666 3.666 0 0110.667 6h22a3.666 3.666 0 013.666 3.667v19.556c0 1.33-.722 2.56-1.886 3.205l-11 6.11a3.664 3.664 0 01-3.562 0l-11-6.11A3.67 3.67 0 017 29.223z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('g',{staticClass:"bcx-icon-shadow"},[_c('mask',{attrs:{"id":"path-5-inside-1_3487_11575x","fill":"#fff"}},[_c('use',{attrs:{"href":"#profile-preferences-flame","stroke-width":"0"}})]),_c('use',{attrs:{"href":"#profile-preferences-flame","fill":"var(--background-color)","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round","mask":"url(#path-5-inside-1_3487_11575x)"}})])])
          )
        }
      }
    